export enum UserRole {
  SUPER_ADMIN = "SUPER_ADMIN",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  MANAGER = "MANAGER",
  USER = "USER",
}
